/**
 * Hook that evaluates public marketing-nav auth gates from Auth + Subscription contexts.
 */

import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import {
  isPublicAuthedNavPending,
  shouldRetargetMarketingSignupCta,
  shouldShowPublicAuthedNav,
  shouldShowPublicOnboardingSoftener,
  type PublicAuthedNavGateInput,
} from '../utils/publicAuthedNavGate';

/**
 * Builds gate inputs and derived flags for PublicNav and marketing CTAs.
 */
export function usePublicAuthedNav() {
  const { isAuthenticated, isLoading: isAuthLoading, termsAccepted, user, isAdmin, logout } = useAuth();
  const { subscription, isLoading: isSubscriptionLoading, requiresOnboarding } = useSubscription();

  const input: PublicAuthedNavGateInput = {
    isAuthLoading,
    isAuthenticated,
    termsAccepted,
    isSubscriptionLoading,
    // Prefer live requiresOnboarding from context when a status payload exists;
    // pass null when status has never loaded so failure fallback works.
    subscription: subscription == null
      ? null
      : { requiresOnboarding },
  };

  return {
    input,
    user,
    isAdmin,
    logout,
    isPending: isPublicAuthedNavPending(input),
    showAuthedNav: shouldShowPublicAuthedNav(input),
    showOnboardingSoftener: shouldShowPublicOnboardingSoftener(input),
    retargetSignupCta: shouldRetargetMarketingSignupCta(input),
  };
}
